exports.__esModule = true;
exports.default = undefined;

var _dec, _class;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./carousel.scss');

require('./jquery.carouFredSel-6.2.1');

require('./jquery.touchSwipe');

var _Sloth = require('../Sloth');

var _Sloth2 = _interopRequireDefault(_Sloth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousel = (_dec = _Sloth2.default.component({
    defaultOptions: {
        width: null,
        visible: 1,
        height: 'variable',
        auto: true,
        pauseOnHover: true,
        time: 2000,
        duration: 500
    }
}), _dec(_class = function () {
    function Carousel() {
        _classCallCheck(this, Carousel);
    }

    Carousel.prototype.onInit = function onInit() {
        var dom = this.dom;
        var options = this.options;
        var onCurrentChange = options.visible > 1 ? _jquery2.default.noop : function () {
            (0, _jquery2.default)('ul', dom).triggerHandler('currentVisible', function (item) {
                if (!item || item.length === 0) {
                    return;
                }
                var binds = (0, _jquery2.default)(item).attrs('data');
                for (var key in binds) {
                    if (_jquery2.default.prototype.hasOwnProperty.call(binds, key)) {
                        (0, _jquery2.default)('[data-bind=\'' + key + '\']', dom).html(binds[key]);
                    }
                }
                (0, _jquery2.default)('[data-link]', dom).attr('href', (0, _jquery2.default)('a', item).attr('href'));
            });
            (0, _jquery2.default)('ul', dom).trigger('currentChange');
        };
        this.pluginIntro();
        this.pluginExif();

        if (options.visible > 1) {
            (0, _jquery2.default)('.Carousel-pic', dom).css({
                'margin-left': '-15px',
                'margin-right': '-15px'
            });
            (0, _jquery2.default)('ul li', dom).css({
                'padding-left': '15px',
                'padding-right': '15px'
            });
        }

        (0, _jquery2.default)('ul', dom).carouFredSel({
            auto: {
                play: options.auto,
                pauseDuration: options.pauseduration,
                timeoutDuration: options.time
            },
            responsive: true,
            width: '100%',
            height: 'variable',
            onCreate: onCurrentChange,
            scroll: {
                pauseOnHover: options.pauseOnHover,
                onAfter: onCurrentChange,
                duration: options.duration
            },
            items: {
                visible: options.visible,
                width: options.width,
                height: options.height
            },
            swipe: {
                onTouch: true
            },
            pagination: (0, _jquery2.default)('.Carousel-pager', dom),
            prev: (0, _jquery2.default)('.Carousel-prev', dom),
            next: (0, _jquery2.default)('.Carousel-next', dom)
        });

        this.adjustBtnPosition();
        (0, _jquery2.default)('ul', dom).trigger('updateSizes'); // 最后调整下
    };

    Carousel.prototype.adjustBtnPosition = function adjustBtnPosition() {
        var dom = this.dom;
        var options = this.options;

        if (options.visible === 1) {
            return;
        }
        var textHeight = parseInt((0, _jquery2.default)('ul', dom).css('height')) - parseInt((0, _jquery2.default)('.Carousel-pic img', dom).eq(0).css('height'));
        var selfHeight = (0, _jquery2.default)('.Carousel-prev', dom).height();
        (0, _jquery2.default)('.Carousel-prev, .Carousel-next', dom).css({
            'margin-top': 0 - selfHeight / 2 - textHeight / 2
        });
        (0, _jquery2.default)('.Carousel-pic li', dom).css({
            'padding-left': 15,
            'padding-right': 15
        });
    };

    Carousel.prototype.pluginExif = function pluginExif() {
        var _this = this;

        if ((0, _jquery2.default)('.CarouselPluginExif', this.dom).length === 0) {
            return;
        }
        (0, _jquery2.default)('.CarouselPluginExif', this.dom).each(function (index, obj) {
            (0, _jquery2.default)('.CarouselPluginExif-button', obj).on('click', function () {
                (0, _jquery2.default)('.CarouselPluginExif', _this.dom).toggleClass('CarouselPluginExif_hide');
            });
        });
    };

    Carousel.prototype.pluginIntro = function pluginIntro() {
        if ((0, _jquery2.default)('.CarouselPluginIntro', this.dom).length === 0) {
            return;
        }
        var that = this;
        (0, _jquery2.default)('.CarouselPluginIntro-num .total', this.dom).html((0, _jquery2.default)('.Carousel-pic li', this.dom).length);
        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).on('click', function () {
            var isOpen = !(0, _jquery2.default)(this).hasClass('CarouselPluginIntro-toggle_up');
            if (isOpen) {
                that.collapse(this.dom);
            } else {
                that.expend(this.dom);
            }
        });
        (0, _jquery2.default)('ul', this.dom).on('currentChange', function () {
            that.onChange(this.dom);
        });
    };

    Carousel.prototype.collapse = function collapse() {
        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).addClass('CarouselPluginIntro-toggle_up');
        (0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).slideUp();
        (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
    };

    Carousel.prototype.expend = function expend() {
        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).removeClass('CarouselPluginIntro-toggle_up');
        (0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).slideDown();
        (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
    };

    Carousel.prototype.onChange = function onChange() {
        var currentPosition = (0, _jquery2.default)('ul', this.dom).triggerHandler('currentPosition');
        (0, _jquery2.default)('.CarouselPluginIntro-num .current', this.dom).html(currentPosition + 1);
        if ((0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).html() === '') {
            (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).hide();
            (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
        } else {
            (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).show();
            (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
        }
    };

    return Carousel;
}()) || _class);
exports.default = Carousel;


/*****************
 ** WEBPACK FOOTER
 ** ./~/slothd/dist/Carousel/carousel.js
 ** module id = 17
 ** module chunks = 0
 **/